import { render, staticRenderFns } from "./LsSources.vue?vue&type=template&id=68630280&scoped=true&"
import script from "./LsSources.vue?vue&type=script&lang=js&"
export * from "./LsSources.vue?vue&type=script&lang=js&"
import style0 from "./LsSources.vue?vue&type=style&index=0&id=68630280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68630280",
  null
  
)

export default component.exports